var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopic4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 91.74 140.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:url(#linear-gradient-10);}.cls-3{fill:url(#linear-gradient-12);}.cls-4{fill:#161617;}.cls-5{fill:#683333;}.cls-6{fill:#090909;}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#radial-gradient);}.cls-9{fill:url(#radial-gradient-3);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-8);}.cls-13{fill:url(#radial-gradient-2);}.cls-14{fill:url(#radial-gradient-4);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-6);}.cls-19{fill:#c96;}.cls-20{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 45.54,
    cy: 77.13,
    fx: 45.54,
    fy: 77.13,
    r: 45.57,
    gradientTransform: "translate(0 125.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#683333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9a6733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 782.44,
    cy: -2859.48,
    fx: 782.44,
    fy: -2859.48,
    r: 5.64,
    gradientTransform: "translate(551.37 -2870.62) rotate(24.79) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#683333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9a6733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 132.37,
    cy: 68.05,
    fx: 132.37,
    fy: 68.05,
    r: 1.48,
    gradientTransform: "translate(-31.76 153.16) rotate(-20.21) scale(1 -1)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 140.79,
    cy: 58.53,
    fx: 140.79,
    fy: 58.53,
    r: 1.48,
    gradientTransform: "translate(-31.76 153.16) rotate(-20.21) scale(1 -1)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 898.75,
    y1: -2973.27,
    x2: 897.48,
    y2: -2974.28,
    gradientTransform: "translate(163.58 -3923.25) rotate(33.02) scale(1.19 -1.14) skewX(-15.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b17d45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#9a6a30",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#87592d",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7a4f29",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#73482a",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704629",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 900.8,
    y1: -2971.65,
    x2: 900.37,
    y2: -2972.08,
    gradientTransform: "translate(163.58 -3923.25) rotate(33.02) scale(1.19 -1.14) skewX(-15.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#683333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#704629",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 121.25,
    y1: 46.44,
    x2: 122.42,
    y2: 46.44,
    gradientTransform: "translate(-75.13 35.33) rotate(-20.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 768.25,
    y1: -2847.96,
    x2: 771.75,
    y2: -2844.46,
    gradientTransform: "translate(551.37 -2870.62) rotate(24.79) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#683333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#7d4833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#8d5933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#966333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9a6733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 904.81,
    y1: -2993.52,
    x2: 902.87,
    y2: -2995.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 907.94,
    y1: -2991.03,
    x2: 907.28,
    y2: -2991.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 112.55,
    y1: 71.63,
    x2: 114.33,
    y2: 71.63,
    gradientTransform: "translate(-75.13 35.33) rotate(-20.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 779.92,
    y1: -2871.93,
    x2: 785.27,
    y2: -2866.58,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 889.11,
    y1: -2987.77,
    x2: 886.01,
    y2: -2990.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 894.1,
    y1: -2983.8,
    x2: 893.05,
    y2: -2984.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 107.84,
    y1: 51.62,
    x2: 110.68,
    y2: 51.62,
    gradientTransform: "translate(-75.13 35.33) rotate(-20.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 762.45,
    y1: -2861.12,
    x2: 770.99,
    y2: -2852.57,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,109.76v-8.65c.36-.08.74-.14,1.13-.19.39-.04.8-.07,1.22-.07,1.19,0,2.09.25,2.69.76.6.51.9,1.31.9,2.42,0,1.03-.29,1.82-.88,2.36-.59.54-1.45.8-2.59.8-.13,0-.26,0-.36,0-.11,0-.22-.01-.34-.01v2.58H0ZM2.48,105.77c.59,0,1.02-.13,1.31-.4s.43-.7.43-1.31-.14-1.08-.42-1.36-.71-.42-1.29-.42c-.15,0-.28,0-.4.01-.12,0-.24.02-.35.05v3.39c.12.02.24.03.35.03.11,0,.24,0,.38,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.75,109.76v-9.6h1.73v3.79h.08c.17-.25.38-.45.64-.59.25-.14.56-.21.92-.21.32,0,.61.07.87.22s.47.38.63.72c.16.33.24.78.24,1.35v4.31h-1.73v-4.17c0-.34-.07-.57-.2-.7s-.3-.19-.52-.19c-.1,0-.21.02-.33.05-.12.03-.22.08-.33.15-.1.07-.2.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.11,109.76l-1.85-6.5h1.78l1.6,6.5h-1.53ZM13.91,112.37l.75-2.62.52-1.38,1.29-5.12h1.72l-2.6,9.12h-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.09,109.88c-.3,0-.59-.02-.87-.07-.28-.04-.55-.11-.81-.2v-1.38c.26.08.53.15.8.2s.56.07.85.07c.35,0,.61-.06.76-.18.15-.12.23-.28.23-.48,0-.17-.04-.3-.13-.39s-.21-.15-.39-.2l-.83-.2c-.49-.12-.86-.33-1.11-.64-.25-.3-.38-.71-.38-1.22,0-.61.22-1.11.67-1.48.45-.37,1.1-.56,1.97-.56.27,0,.52.01.76.04.24.03.46.07.66.12v1.38c-.22-.05-.43-.1-.64-.12-.21-.03-.44-.04-.69-.04-.29,0-.52.03-.69.09-.17.06-.29.15-.36.25-.07.1-.11.21-.11.32,0,.16.04.27.13.36.08.08.21.15.38.2l.83.21c.5.12.87.33,1.12.62.25.29.37.7.37,1.22,0,.65-.23,1.15-.68,1.52s-1.07.56-1.85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.13,102.3c-.37,0-.64-.09-.82-.26-.18-.17-.27-.41-.27-.71s.09-.55.27-.72c.18-.17.45-.26.82-.26s.65.09.82.26c.18.17.26.41.26.72s-.09.54-.26.71c-.18.17-.45.26-.82.26ZM23.27,109.76v-6.5h1.74v6.5h-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.66,109.88c-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.6-.98-1.09-.22-.5-.33-1.14-.33-1.93s.12-1.45.38-1.95c.25-.49.61-.85,1.07-1.08.46-.22,1.01-.34,1.65-.34.2,0,.4,0,.59.03.19.02.38.05.56.09v1.42c-.14-.03-.28-.05-.43-.07-.15-.01-.28-.02-.4-.02-.37,0-.68.06-.92.18-.24.12-.41.31-.53.59s-.17.64-.17,1.11c0,.5.05.89.16,1.17.11.28.27.48.48.6.21.12.48.17.8.17.15,0,.31-.02.47-.05.16-.03.34-.08.53-.14v1.43c-.22.08-.45.13-.69.17-.24.04-.47.05-.7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.2,109.88c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45.38-.35.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.39-.34-.18-.07-.42-.1-.73-.1-.22,0-.47.02-.74.06s-.53.1-.79.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.95-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.25.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.29,109.76v-9.6h1.73v9.6h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.07,107.1v-1.42h3.22v1.42h-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.07,109.87c-.61,0-1.17-.08-1.65-.24s-.9-.42-1.24-.78-.6-.82-.78-1.39c-.18-.57-.27-1.26-.27-2.08,0-1.05.16-1.91.48-2.58.32-.67.79-1.16,1.39-1.47.6-.32,1.33-.47,2.18-.47.28,0,.55.02.83.05.28.03.54.08.79.15v1.49c-.25-.06-.5-.11-.74-.14-.24-.03-.49-.05-.75-.05-.52,0-.95.09-1.3.28-.35.19-.61.5-.79.94-.18.44-.27,1.04-.27,1.79s.09,1.39.26,1.83c.18.44.44.75.78.93.34.18.78.27,1.3.27.22,0,.46-.02.71-.07.25-.05.51-.12.79-.21v1.49c-.23.09-.5.16-.81.21-.31.05-.62.08-.93.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.48,109.76v-9.6h1.73v3.79h.08c.17-.25.38-.45.64-.59.25-.14.56-.21.92-.21.32,0,.61.07.87.22s.47.38.63.72c.16.33.24.78.24,1.35v4.31h-1.73v-4.17c0-.34-.07-.57-.2-.7s-.3-.19-.52-.19c-.1,0-.21.02-.33.05-.12.03-.22.08-.33.15-.1.07-.2.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.45,109.88c-.72,0-1.32-.12-1.78-.34-.46-.23-.8-.59-1.02-1.09s-.33-1.15-.33-1.96c0-.74.1-1.35.31-1.85.21-.5.51-.87.9-1.11.39-.25.87-.37,1.42-.37s.98.12,1.34.37c.36.25.64.62.83,1.12.19.5.28,1.13.28,1.88v.51h-3.82v-1.06h2.45l-.25.11c0-.48-.03-.85-.09-1.11-.06-.26-.16-.43-.28-.53-.12-.1-.28-.15-.46-.15s-.34.05-.47.15c-.13.1-.23.27-.3.53-.07.26-.1.63-.1,1.11v.76c0,.42.05.74.15.98.1.24.26.41.49.51.23.1.54.15.93.15.23,0,.46-.02.7-.06.24-.04.48-.09.74-.16v1.39c-.3.08-.58.13-.84.17-.26.04-.53.05-.81.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.14,109.76v-6.5h1.44l.13.69h.08c.21-.27.45-.47.72-.6s.57-.19.91-.19c.31,0,.6.07.86.21.26.14.46.37.61.69.15.32.23.76.23,1.3v4.4h-1.69v-4.21c0-.33-.06-.55-.19-.67-.12-.12-.29-.18-.48-.18-.1,0-.2.02-.3.05-.11.03-.21.09-.31.16-.1.07-.19.17-.26.29v4.56h-1.73ZM67.64,109.76v-4.21c0-.33-.07-.55-.2-.67s-.3-.18-.5-.18c-.1,0-.2.02-.31.05-.11.04-.22.09-.33.17-.11.08-.2.18-.28.31l-.31-1.07c.22-.34.49-.6.82-.76.32-.17.66-.25,1-.25s.65.07.93.22.5.39.66.72.24.79.24,1.36v4.3h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.25,102.3c-.37,0-.64-.09-.82-.26-.18-.17-.27-.41-.27-.71s.09-.55.27-.72c.18-.17.45-.26.82-.26s.65.09.82.26c.18.17.26.41.26.72s-.09.54-.26.71c-.18.17-.45.26-.82.26ZM70.38,109.76v-6.5h1.74v6.5h-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.7,109.88c-.3,0-.59-.02-.87-.07-.28-.04-.55-.11-.81-.2v-1.38c.26.08.53.15.8.2s.56.07.85.07c.35,0,.61-.06.76-.18.15-.12.23-.28.23-.48,0-.17-.04-.3-.13-.39s-.21-.15-.39-.2l-.83-.2c-.49-.12-.86-.33-1.11-.64-.25-.3-.38-.71-.38-1.22,0-.61.22-1.11.67-1.48.45-.37,1.1-.56,1.97-.56.27,0,.52.01.76.04.24.03.46.07.66.12v1.38c-.22-.05-.43-.1-.64-.12-.21-.03-.44-.04-.69-.04-.29,0-.52.03-.69.09-.17.06-.29.15-.36.25-.07.1-.11.21-.11.32,0,.16.04.27.13.36.08.08.21.15.38.2l.83.21c.5.12.87.33,1.12.62.25.29.37.7.37,1.22,0,.65-.23,1.15-.68,1.52s-1.07.56-1.85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.24,104.62v-1.37h4.16v1.37h-4.16ZM80.39,109.87c-.7,0-1.25-.18-1.63-.55-.39-.37-.58-.98-.58-1.83v-4.23l.32-2.29h1.41v6.32c0,.42.07.7.21.86s.38.24.72.24c.09,0,.18,0,.28-.01.1,0,.2-.02.32-.04v1.42c-.14.04-.31.07-.49.09s-.37.04-.55.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.04,109.76v-6.5h1.42l.14.9h.08c.15-.36.37-.62.63-.77.27-.15.57-.23.89-.23.08,0,.16,0,.24.01.08,0,.15.02.2.03v1.61c-.09-.02-.18-.03-.27-.03-.09,0-.19,0-.28,0-.18,0-.35.02-.52.07-.17.05-.33.12-.47.22-.14.1-.25.21-.34.34v4.34h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.63,109.76l-1.85-6.5h1.78l1.6,6.5h-1.53ZM87.44,112.37l.75-2.62.52-1.38,1.29-5.12h1.72l-2.6,9.12h-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.33,124.15c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09s-.32-1.13-.32-1.9.11-1.43.32-1.93.52-.87.93-1.1c.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM7.33,122.84c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6.07-.29.11-.72.11-1.27s-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.14,118.89v-1.37h4.14v1.37h-4.14ZM11.07,124.02v-7.16c0-.54.1-1,.29-1.39.19-.38.48-.67.87-.87.39-.2.87-.3,1.45-.3.13,0,.27,0,.41.02.14,0,.28.03.41.05v1.39c-.1-.02-.2-.03-.29-.04-.09,0-.18-.01-.28-.01-.4,0-.7.08-.88.25-.18.17-.27.43-.27.8v7.26h-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.16,124.02v-8.79h1.76l3.55,6.39h-.3v-6.39h1.65v8.79h-1.76l-3.55-6.39h.3v6.39h-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.44,124.14c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45.38-.35.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.39-.34-.18-.07-.42-.1-.73-.1-.22,0-.47.02-.74.06s-.53.1-.79.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.95-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.25.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.53,124.02v-6.5h1.44l.13.69h.08c.2-.26.44-.46.71-.59s.58-.2.92-.2.66.07.93.22.49.38.65.72c.16.33.24.78.24,1.34v4.33h-1.73v-4.2c0-.33-.07-.55-.2-.68s-.3-.18-.52-.18c-.11,0-.22.02-.33.05-.12.03-.22.09-.33.16-.1.07-.19.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.09,124.15c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09s-.32-1.13-.32-1.9.11-1.43.32-1.93.52-.87.93-1.1c.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM39.09,122.84c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6.07-.29.11-.72.11-1.27s-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.59,124.02v-6.5h1.44l.13.69h.08c.21-.27.45-.47.72-.6s.57-.19.91-.19c.31,0,.6.07.86.21.26.14.46.37.61.69.15.32.23.76.23,1.3v4.4h-1.69v-4.21c0-.33-.06-.55-.19-.67-.12-.12-.29-.18-.48-.18-.1,0-.2.02-.3.05-.11.03-.21.09-.31.16-.1.07-.19.17-.26.29v4.56h-1.73ZM49.09,124.02v-4.21c0-.33-.07-.55-.2-.67s-.3-.18-.5-.18c-.1,0-.2.02-.31.05-.11.04-.22.09-.33.17-.11.08-.2.18-.28.31l-.31-1.07c.22-.34.49-.6.82-.76.32-.17.66-.25,1-.25s.65.07.93.22.5.39.66.72.24.79.24,1.36v4.3h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.34,124.14c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45.38-.35.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.39-.34-.18-.07-.42-.1-.73-.1-.22,0-.47.02-.74.06s-.53.1-.79.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.95-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.25.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.85,118.89v-1.37h4.16v1.37h-4.16ZM60,124.13c-.7,0-1.25-.18-1.63-.55-.39-.37-.58-.98-.58-1.83v-4.23l.32-2.29h1.41v6.32c0,.42.07.7.21.86s.38.24.72.24c.09,0,.18,0,.28-.01.1,0,.2-.02.32-.04v1.42c-.14.04-.31.07-.49.09s-.37.04-.55.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.45,124.15c-.72,0-1.32-.12-1.78-.34-.46-.23-.8-.59-1.02-1.09s-.33-1.15-.33-1.96c0-.74.1-1.35.31-1.85.21-.5.51-.87.9-1.11.39-.25.87-.37,1.42-.37s.98.12,1.34.37c.36.25.64.62.83,1.12.19.5.28,1.13.28,1.88v.51h-3.82v-1.06h2.45l-.25.11c0-.48-.03-.85-.09-1.11-.06-.26-.16-.43-.28-.53-.12-.1-.28-.15-.46-.15s-.34.05-.47.15c-.13.1-.23.27-.3.53-.07.26-.1.63-.1,1.11v.76c0,.42.05.74.15.98.1.24.26.41.49.51.23.1.54.15.93.15.23,0,.46-.02.7-.06.24-.04.48-.09.74-.16v1.39c-.3.08-.58.13-.84.17-.26.04-.53.05-.81.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.14,124.02v-6.5h1.42l.14.9h.08c.15-.36.37-.62.63-.77.27-.15.57-.23.89-.23.08,0,.16,0,.24.01.08,0,.15.02.2.03v1.61c-.09-.02-.18-.03-.27-.03-.09,0-.19,0-.28,0-.18,0-.35.02-.52.07-.17.05-.33.12-.47.22-.14.1-.25.21-.34.34v4.34h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.22,116.56c-.37,0-.64-.09-.82-.26-.18-.17-.27-.41-.27-.71s.09-.55.27-.72c.18-.17.45-.26.82-.26s.65.09.82.26c.18.17.26.41.26.72s-.09.54-.26.71c-.18.17-.45.26-.82.26ZM71.35,124.02v-6.5h1.74v6.5h-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.63,124.14c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45.38-.35.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.39-.34-.18-.07-.42-.1-.73-.1-.22,0-.47.02-.74.06s-.53.1-.79.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.95-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.25.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.73,124.02v-9.6h1.73v9.6h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.04,124.15c-.3,0-.59-.02-.87-.07-.28-.04-.55-.11-.81-.2v-1.38c.26.08.53.15.8.2s.56.07.85.07c.35,0,.61-.06.76-.18.15-.12.23-.28.23-.48,0-.17-.04-.3-.13-.39s-.21-.15-.39-.2l-.83-.2c-.49-.12-.86-.33-1.11-.64-.25-.3-.38-.71-.38-1.22,0-.61.22-1.11.67-1.48.45-.37,1.1-.56,1.97-.56.27,0,.52.01.76.04.24.03.46.07.66.12v1.38c-.22-.05-.43-.1-.64-.12-.21-.03-.44-.04-.69-.04-.29,0-.52.03-.69.09-.17.06-.29.15-.36.25-.07.1-.11.21-.11.32,0,.16.04.27.13.36.08.08.21.15.38.2l.83.21c.5.12.87.33,1.12.62.25.29.37.7.37,1.22,0,.65-.23,1.15-.68,1.52s-1.07.56-1.85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.26,138.4c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45.38-.35.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.39-.34-.18-.07-.42-.1-.73-.1-.22,0-.47.02-.74.06s-.53.1-.79.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.95-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.25.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.35,138.28v-6.5h1.44l.13.69h.08c.2-.26.44-.46.71-.59s.58-.2.92-.2.66.07.93.22.49.38.65.72c.16.33.24.78.24,1.34v4.33h-1.73v-4.2c0-.33-.07-.55-.2-.68s-.3-.18-.52-.18c-.11,0-.22.02-.33.05-.12.03-.22.09-.33.16-.1.07-.19.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.46,138.41c-.4,0-.77-.11-1.11-.33s-.62-.56-.83-1.04-.32-1.1-.32-1.88.12-1.4.35-1.92c.23-.52.59-.91,1.07-1.17s1.09-.39,1.84-.39c.06,0,.12,0,.18,0s.11,0,.16.02v-3.03h1.74v9.6h-1.47l-.12-.69h-.08c-.12.24-.3.44-.54.59-.24.15-.52.23-.85.23ZM17.02,136.95c.15,0,.29-.03.43-.1.14-.06.25-.15.34-.27v-3.51c-.07-.02-.15-.03-.24-.03-.09,0-.17,0-.24,0-.44,0-.77.14-1,.42s-.34.8-.34,1.56c0,.53.05.93.14,1.21s.22.47.37.57c.16.1.34.15.54.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.09,138.28v-8.79h1.76l3.55,6.39h-.3v-6.39h1.65v8.79h-1.76l-3.55-6.39h.3v6.39h-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.36,138.4c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45.38-.35.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.39-.34-.18-.07-.42-.1-.73-.1-.22,0-.47.02-.74.06s-.53.1-.79.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.95-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.25.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.46,138.28v-6.5h1.44l.13.69h.08c.2-.26.44-.46.71-.59s.58-.2.92-.2.66.07.93.22.49.38.65.72c.16.33.24.78.24,1.34v4.33h-1.73v-4.2c0-.33-.07-.55-.2-.68s-.3-.18-.52-.18c-.11,0-.22.02-.33.05-.12.03-.22.09-.33.16-.1.07-.19.17-.27.28v4.58h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.02,138.41c-.57,0-1.06-.12-1.46-.35-.41-.23-.72-.6-.93-1.09s-.32-1.13-.32-1.9.11-1.43.32-1.93.52-.87.93-1.1c.4-.24.89-.35,1.47-.35s1.05.12,1.46.36c.41.24.72.61.93,1.11.21.5.32,1.13.32,1.9s-.11,1.42-.32,1.91-.52.86-.93,1.09c-.4.23-.89.35-1.46.35ZM45.02,137.11c.2,0,.37-.05.51-.16.14-.11.25-.31.32-.6.07-.29.11-.72.11-1.27s-.04-1.01-.11-1.31c-.08-.3-.18-.51-.32-.62-.14-.11-.31-.17-.5-.17s-.37.05-.51.16c-.14.11-.25.31-.32.61s-.11.73-.11,1.29.04.99.11,1.29.18.5.32.61c.14.11.31.16.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.21,138.41c-.61,0-1.13-.12-1.56-.35-.43-.23-.75-.6-.98-1.09-.22-.5-.33-1.14-.33-1.93s.12-1.45.38-1.95c.25-.49.61-.85,1.07-1.08.46-.22,1.01-.34,1.65-.34.2,0,.4,0,.59.03.19.02.38.05.56.09v1.42c-.14-.03-.28-.05-.43-.07-.15-.01-.28-.02-.4-.02-.37,0-.68.06-.92.18-.24.12-.41.31-.53.59s-.17.64-.17,1.11c0,.5.05.89.16,1.17.11.28.27.48.48.6.21.12.48.17.8.17.15,0,.31-.02.47-.05.16-.03.34-.08.53-.14v1.43c-.22.08-.45.13-.69.17-.24.04-.47.05-.7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.75,138.4c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45.38-.35.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.39-.34-.18-.07-.42-.1-.73-.1-.22,0-.47.02-.74.06s-.53.1-.79.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.95-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.25.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.27,133.15v-1.37h4.16v1.37h-4.16ZM61.42,138.4c-.7,0-1.25-.18-1.63-.55-.39-.37-.58-.98-.58-1.83v-4.23l.32-2.29h1.41v6.32c0,.42.07.7.21.86s.38.24.72.24c.09,0,.18,0,.28-.01.1,0,.2-.02.32-.04v1.42c-.14.04-.31.07-.49.09s-.37.04-.55.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.57,138.4c-.54,0-.98-.17-1.31-.5-.34-.33-.5-.79-.5-1.36,0-.62.19-1.1.56-1.45.38-.35.99-.55,1.84-.62l1.04-.09.24,1.01-1.08.09c-.3.02-.53.11-.68.25-.15.15-.23.35-.23.61s.07.46.2.58c.13.13.31.19.53.19.13,0,.27-.03.41-.09s.27-.17.39-.32v-2.53c0-.28-.04-.5-.12-.66-.08-.16-.21-.27-.39-.34-.18-.07-.42-.1-.73-.1-.22,0-.47.02-.74.06s-.53.1-.79.18v-1.39c.27-.08.58-.13.91-.17.33-.04.65-.06.95-.06.59,0,1.08.08,1.46.24.38.16.67.43.85.81.18.38.28.88.28,1.52v4.03h-1.41l-.13-.68h-.08c-.15.29-.36.49-.62.62-.25.12-.54.19-.85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.67,138.28v-9.6h1.73v9.6h-1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.69,138.28l-1.85-6.5h1.78l1.6,6.5h-1.53ZM72.49,140.9l.75-2.62.52-1.38,1.29-5.12h1.72l-2.6,9.12h-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.67,138.41c-.3,0-.59-.02-.87-.07-.28-.04-.55-.11-.81-.2v-1.38c.26.08.53.15.8.2s.56.07.85.07c.35,0,.61-.06.76-.18.15-.12.23-.28.23-.48,0-.17-.04-.3-.13-.39s-.21-.15-.39-.2l-.83-.2c-.49-.12-.86-.33-1.11-.64-.25-.3-.38-.71-.38-1.22,0-.61.22-1.11.67-1.48.45-.37,1.1-.56,1.97-.56.27,0,.52.01.76.04.24.03.46.07.66.12v1.38c-.22-.05-.43-.1-.64-.12-.21-.03-.44-.04-.69-.04-.29,0-.52.03-.69.09-.17.06-.29.15-.36.25-.07.1-.11.21-.11.32,0,.16.04.27.13.36.08.08.21.15.38.2l.83.21c.5.12.87.33,1.12.62.25.29.37.7.37,1.22,0,.65-.23,1.15-.68,1.52s-1.07.56-1.85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.71,130.83c-.37,0-.64-.09-.82-.26-.18-.17-.27-.41-.27-.71s.09-.55.27-.72c.18-.17.45-.26.82-.26s.65.09.82.26c.18.17.26.41.26.72s-.09.54-.26.71c-.18.17-.45.26-.82.26ZM81.85,138.28v-6.5h1.74v6.5h-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.17,138.41c-.3,0-.59-.02-.87-.07-.28-.04-.55-.11-.81-.2v-1.38c.26.08.53.15.8.2s.56.07.85.07c.35,0,.61-.06.76-.18.15-.12.23-.28.23-.48,0-.17-.04-.3-.13-.39s-.21-.15-.39-.2l-.83-.2c-.49-.12-.86-.33-1.11-.64-.25-.3-.38-.71-.38-1.22,0-.61.22-1.11.67-1.48.45-.37,1.1-.56,1.97-.56.27,0,.52.01.76.04.24.03.46.07.66.12v1.38c-.22-.05-.43-.1-.64-.12-.21-.03-.44-.04-.69-.04-.29,0-.52.03-.69.09-.17.06-.29.15-.36.25-.07.1-.11.21-.11.32,0,.16.04.27.13.36.08.08.21.15.38.2l.83.21c.5.12.87.33,1.12.62.25.29.37.7.37,1.22,0,.65-.23,1.15-.68,1.52s-1.07.56-1.85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.46,24.19h0c-.37-.62-.89-1.14-1.52-1.51L47.62.57c-.64-.36-1.36-.56-2.09-.57h0c-.73,0-1.44.2-2.07.57L5.14,22.68c-.64.37-1.18.9-1.55,1.53-.37.64-.57,1.36-.57,2.09v44.26c0,.74.2,1.47.57,2.12h.06c.37.62.9,1.13,1.52,1.48l38.31,22.12c.65.36,1.38.56,2.12.57h0c.72,0,1.42-.2,2.04-.55l38.32-22.12c.63-.37,1.16-.9,1.53-1.53.36-.63.56-1.35.57-2.08V26.31c-.01-.75-.22-1.47-.59-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.58,93.31c-.72,0-1.43-.2-2.06-.55l-35.32-20.4c-.58-.32-1.07-.79-1.43-1.35h0l-.08-.1c-.36-.63-.55-1.34-.55-2.06V28.04c0-.72.19-1.43.55-2.05.37-.62.89-1.14,1.51-1.5L43.49,4.1c.61-.36,1.31-.55,2.02-.55h0c.71,0,1.42.19,2.04.55l35.36,20.43c.58.33,1.07.81,1.42,1.38h0l.07.09c.35.63.54,1.34.55,2.06v40.81c0,.71-.2,1.41-.55,2.03-.36.62-.88,1.13-1.5,1.49l-35.32,20.37c-.58.33-1.22.52-1.89.54h-.12ZM7.03,70.6l.07.08c.32.53.78.96,1.32,1.26l35.32,20.4c.54.3,1.14.46,1.76.48h.08c.62,0,1.23-.17,1.77-.48l35.32-20.39c1.12-.65,1.81-1.85,1.82-3.14V28.04c0-.62-.16-1.22-.45-1.77l-.06-.08c-.32-.54-.77-.99-1.31-1.31L47.36,4.49c-.55-.31-1.18-.48-1.81-.48h0c-.63,0-1.25.17-1.8.48L8.42,24.88c-.55.32-1.02.78-1.35,1.33-.32.55-.49,1.17-.49,1.81v40.81c0,.61.16,1.22.45,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M57.7,31.65c-6.6-11.33-14.58-16.82-20.14-14.79h0c-2.56.94-4.99,2.2-7.24,3.75h0l-.09.08c-14.84,10.3-18.51,30.68-8.21,45.52,8.49,12.23,24.17,17.18,38.15,12.04h.03c1.84-.77,3.34-2.16,4.23-3.94,4.86-8.78,1.85-27.91-6.74-42.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.7,31.65c-6.6-11.33-14.58-16.82-20.14-14.79h0c-1.2.46-2.26,1.22-3.07,2.22h0l-.03.06c-.44.52-.82,1.08-1.15,1.67-4.9,8.75-1.88,27.88,6.7,42.64,6.6,11.33,14.58,16.83,20.16,14.83h.03c1.84-.77,3.34-2.16,4.23-3.94,4.86-8.8,1.86-27.93-6.73-42.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 62.76,
    cy: 53.43,
    r: 5.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 68.96,
    cy: 43.56,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 80.14,
    cy: 49.6,
    r: 1.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M52.39,30.75c-.6.22-.06,3.21,1.21,6.67,1.27,3.46,2.8,6.09,3.4,5.86l-4.61-12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.99,32.37c-.3.11.22,2.28,1.16,4.84s1.95,4.55,2.25,4.44l-3.42-9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M57,43.28c.6-.22.06-3.21-1.21-6.67-1.27-3.46-2.8-6.09-3.4-5.86l4.61,12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M59.36,35.31c-.95-2.57-3.79-3.89-6.36-2.94l3.43,9.31c2.57-.95,3.88-3.8,2.94-6.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 69.46,
    cy: 35.76,
    r: 4.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 73.39,
    cy: 25.77,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 70.3,
    cy: 50.66,
    r: 3.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 76.22,
    cy: 53.39,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 70.62,
    cy: 60.35,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 61.72,
    cy: 27.98,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 50.89,
    cy: 27.51,
    r: 9.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 58.14,
    cy: 44.6,
    r: 7.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51.72,54.09c-.92.34-.09,4.9,1.86,10.19,1.95,5.28,4.27,9.3,5.19,8.96l-7.05-19.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M52.63,56.58c-.46.17.34,3.48,1.78,7.4,1.44,3.91,2.99,6.95,3.45,6.79l-5.22-14.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M58.76,73.24c.92-.34.09-4.9-1.86-10.19-1.95-5.29-4.27-9.3-5.19-8.96l7.05,19.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M62.36,61.07c-1.44-3.92-5.8-5.94-9.72-4.49l5.23,14.22c3.92-1.45,5.93-5.8,4.49-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M38.28,31.24c-1.47.54-.14,7.83,2.96,16.26,3.1,8.43,6.82,14.84,8.29,14.3l-11.25-30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.74,35.2c-.73.27.54,5.56,2.84,11.81,2.3,6.25,4.77,11.1,5.5,10.83l-8.33-22.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M49.53,61.8c1.47-.54.14-7.82-2.96-16.26-3.11-8.44-6.82-14.84-8.29-14.3l11.25,30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.26,42.37c-2.31-6.26-9.25-9.47-15.52-7.17l8.35,22.69c6.26-2.31,9.47-9.26,7.16-15.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic4);
export default __webpack_public_path__ + "static/media/topic_4.37c757672f7513252b651a3e05250939.svg";
export { ForwardRef as ReactComponent };